module.exports = __webpack_public_path__ + "img/testimonial_3.1af9589a.png";